@if (salesRep | async; as r) {
  @if (r) {
    <app-contact-card *appIfMyself="r._id" [title]="'stax.divisions.rep.type.sales' | translate" [user]="r"></app-contact-card>
    <mat-divider *appIfMyself="r._id"></mat-divider>
  }
}
<ng-content></ng-content>
